import React from 'react';

import Verify from './Verify';
import type PageBaseProps from '../../types/PageBase';

const ReopenVerify: React.FC<PageBaseProps> = (props) => (
  <Verify {...props} hideGTC />
);

export default ReopenVerify;
